import { BrandLogo } from "../components/brand/BrandLogo";
import { RotatingPattern } from "../components/brand/RotatingPattern";
import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Anchor,
  Button,
  Card,
  Center,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { IconAlertCircle, IconMailCheck } from "@tabler/icons-react";
import { authApi } from "../api/auth";
import { errorMessage } from "../lib/axios";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <Center mih="100vh" p="md" bg="var(--surface-canvas)" pos="relative" style={{ overflow: "hidden" }}>
      <RotatingPattern />
      <Card withBorder shadow="sm" radius="lg" padding="xl" pos="relative" style={{ zIndex: 1 }} w={400} maw="100%">
        <Stack gap="xs" mb="md">
          <BrandLogo height={40} />
          <Title order={4} fw={600}>
            Forgot password
          </Title>
          <Text c="dimmed" size="sm">
            Enter your email and we'll send you a reset link.
          </Text>
        </Stack>

        {sent ? (
          <Stack>
            <Alert
              color="green"
              variant="light"
              icon={<IconMailCheck size={16} />}
            >
              If that email is registered, a password reset link is on its way.
              The link expires in 60 minutes.
            </Alert>
            <Anchor component={Link} to="/login" size="sm">
              Back to sign in
            </Anchor>
          </Stack>
        ) : (
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              {error && (
                <Alert color="red" variant="light" icon={<IconAlertCircle size={16} />}>
                  {error}
                </Alert>
              )}
              <TextInput
                label="Email"
                type="email"
                placeholder="you@safiri.tz"
                required
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                autoFocus
              />
              <Button type="submit" fullWidth loading={loading}>
                Send reset link
              </Button>
              <Anchor component={Link} to="/login" size="sm" ta="center">
                Back to sign in
              </Anchor>
            </Stack>
          </form>
        )}
      </Card>
    </Center>
  );
}
